import type { MouseEventHandler } from 'react';

export enum QuickAddToBagButtonVariant {
    BlackText = 'black-text',
    WhiteIcon = 'white-icon',
}

export interface QuickAddToBagButtonProps {
    onClick?: MouseEventHandler<HTMLButtonElement>;
    isLoading: boolean;
    disabled?: boolean;
    className?: string;
    ariaLabel?: string;
    dataTestId?: string;
    variant: QuickAddToBagButtonVariant;
}
